/*
Google Analytics event tracking utility
@eventName: Name of the event to track (string)
@params: Additional parameters for the event (object, parameter names depend on the event, check GA4 custom event)

*/

export const trackEvent = (eventName, params = {}) => {
  if (typeof eventName !== "string" || eventName.length === 0) {
    console.warn("Invalid event name");
    return;
  }

  if (typeof params !== "object") {
    console.warn(eventName, " Params should be an object");
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params,
  });
};

export const trackCtaClick = (label) => {
  trackEvent("cta_click", { label });
};

export const trackFormSubmit = (formName, success) => {
  trackEvent("form_submit", { formName, success });
};

export const trackAddToBag = (productId, productName, quantity = 1) => {
    trackEvent("add_to_bag", { productId, productName, quantity });
};

export const trackRemoveFromBag = (productId, productName, quantity = 1) => {
    trackEvent("remove_from_bag", { productId, productName, quantity });
};

window.trackEvent = trackEvent;
window.trackCtaClick = trackCtaClick;
window.trackFormSubmit = trackFormSubmit;
window.trackAddToBag = trackAddToBag;
window.trackRemoveFromBag = trackRemoveFromBag;